<template>
  <div class="uniform-check-panel">
    <h4>
      全局智能QA
      <el-tooltip
        class="item"
        effect="dark"
        content="全局智能QA将自动对已修改的内容进行QA检查，并将检查结果自动汇总展示"
        placement="top-start"
      >
        <i class="el-icon-question c-p c-primary"></i>
      </el-tooltip>
    </h4>
    <ul v-loading="loading">
      <li v-for="item in uniformErrors" :key="item.type">
        <error-item
          v-if="item.name"
          :error="item"
          @toggleShowDetail="item.showDetail = !item.showDetail"
          @viewClick="handleViewClick(item)"
        />
        <div v-if="item.detail?.length" v-show="item.showDetail">
          <error-item
            v-for="detailItem in item.detail"
            :error="detailItem"
            :isDetail="true"
            :key="detailItem.type"
            @viewClick="
              handleViewClick({
                parent: item,
                ...detailItem,
              })
            "
          />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { getQcCheckCount } from '@/api/qc/qcflow';
import { LOW_ERRORS_MAP, UNIFORM_ERRORS_MAP } from './const';
import { statistics } from '@/api/dot/flow';
import ErrorItem from './ErrorItem.vue';

export default {
  name: 'UniformCheckPanel',
  props: ['visible', 'orderId', 'qcTaskId', 'staParams'],
  components: { ErrorItem },
  data: () => {
    return {
      loading: false,
      // key和后台接口对应
      uniformErrors: [
        {
          key: 'lowCheckCount',
          type: 'lowCheck',
          count: 0,
          detail: [],
          showDetail: false,
        },
        {
          key: 'unUsedTermCount',
          type: 'unUsedTerm',
          count: 0,
        },
        {
          key: 'highTermCount',
          type: 'highTerm',
          count: 0,
        },
        {
          key: 'highSimilarCount',
          type: 'highSimilar',
          count: 0,
        },
        {
          key: 'highCriticalCount',
          type: 'highCritical',
          count: 0,
        },
      ],
    };
  },
  watch: {
    visible: {
      handler(val) {
        val && this.updateErrors();
      },
      immediate: true,
    },
  },
  methods: {
    updateErrors() {
      this.loading = true;
      return getQcCheckCount({
        orderId: this.orderId,
        qcTaskId: this.qcTaskId,
      })
        .then((res) => {
          const keyData = res.data?.data ?? {};
          this.uniformErrors.forEach((item) => {
            item.count = keyData[item.key];
            item.name = UNIFORM_ERRORS_MAP[item.type]?.name;
            item.shortName = UNIFORM_ERRORS_MAP[item.type]?.shortName;
            // 低错有详情
            if (item.key === 'lowCheckCount') {
              item.detail = keyData.lowCheckList?.map((item) => {
                return {
                  ...item,
                  name: LOW_ERRORS_MAP[item.type]?.name,
                  shortName: LOW_ERRORS_MAP[item.type]?.shortName,
                };
              });
            }
          });
        })
        .finally(() => (this.loading = false));
    },
    handleViewClick(item) {
      this.$emit('openFilterMode', item);

      const curItemConfig =
        UNIFORM_ERRORS_MAP[item.type] ?? LOW_ERRORS_MAP[item.type];
      statistics(
        Object.assign(
          {},
          this.staParams,
          {
            scene_code: 'CopilotWorkbench',
            scene_name: '副驾工作页',
          },
          curItemConfig.track,
        ),
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.uniform-check-panel {
  h4 {
    font-weight: normal;
    margin-top: 25px;
  }
  ul {
    li {
      font-size: 14px;
      border: 1px solid #ddd;
      border-radius: 5px;
      padding: 0 10px;
      margin: 10px 0;
    }
  }

  :deep(.error-overview) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    p {
      i.el-icon-arrow-down {
        margin-left: 5px;
        cursor: pointer;
        &.active {
          transform: rotate(180deg);
        }
      }

      .count {
        color: #999;
        margin-right: 10px;
        &.active {
          color: #ed7266;
        }
      }
    }
  }
}
</style>
